/**
 * IAA (inter-annotator agreement) threshold helper.
 *
 * The Datasets and Quality surfaces both colour IAA scores by the same
 * thresholds. Single source of truth so the two stay in lockstep.
 *
 * Mirrors the prototype at `/Users/laurencesonnenberg/dataeq-code/go_lab/
 * go_lab_standalone.html`:
 *   ≥ 0.75 → success
 *   0.65 ≤ x < 0.75 → warning
 *   < 0.65 → error
 *   null  → muted (no IAA computed yet)
 */

export type IaaTone = 'success' | 'warning' | 'error' | 'muted';

export function getIaaTone(iaa: number | null | undefined): IaaTone {
  // `== null` catches both null and undefined; defensive against
  // callers that pass `data?.field` without narrowing first.
  if (iaa == null) return 'muted';
  if (iaa >= 0.75) return 'success';
  if (iaa >= 0.65) return 'warning';
  return 'error';
}

export const IAA_TONE_TEXT_CLASS: Record<IaaTone, string> = {
  success: 'text-emerald-600',
  warning: 'text-amber-600',
  error: 'text-red-600',
  muted: 'text-muted-foreground',
};
